import * as React from 'react';

var _circle, _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgPolkadot = function SvgPolkadot(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 60,
        cy: 60,
        r: 60,
        fill: "#EDF0F4"
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#1E1E1E",
        d: "M60.258 20C43.575 20.067 30.067 33.575 30 50.258c0 3.341.54 6.66 1.596 9.829a4.33 4.33 0 0 0 5.322 2.652 4.307 4.307 0 0 0 2.572-5.304 20 20 0 0 1-1.177-7.713c.364-12.05 10.425-21.524 22.475-21.16 12.05.363 21.524 10.425 21.16 22.475-.341 11.28-9.225 20.442-20.493 21.128 0 0-4.248.259-6.36.517q-1.169.168-2.314.46a.28.28 0 0 1-.395.003l-.004-.003a.28.28 0 0 1 0-.339l.658-3.587 3.989-17.94a4.148 4.148 0 1 0-8.112-1.736S39.43 93.453 39.43 93.852a3.987 3.987 0 0 0 2.952 4.863h.22a3.984 3.984 0 0 0 4.857-2.862q.016-.051.025-.109a1 1 0 0 1 0-.198c.118-.517 1.315-6.36 1.315-6.36a10.76 10.76 0 0 1 8.91-8.472c.915-.14 4.764-.399 4.764-.399 16.62-1.656 28.749-16.472 27.09-33.092C88.048 32.066 75.492 20.396 60.257 20"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#E6007A",
        d: "M62.093 89.767a5.04 5.04 0 0 0-5.964 3.91l-.016.076a5.02 5.02 0 0 0 3.849 5.98h.14a4.94 4.94 0 0 0 5.964-3.644q.009-.031.016-.06v-.278a5.23 5.23 0 0 0-3.989-5.984"
    })));
};

export { SvgPolkadot as ReactComponent };
//# sourceMappingURL=Polkadot.svg.es.js.map
